import { useCallback, useState } from 'react';

export const useCopyToClipboard = (text: string | number): any => {
  const copyToClipboard = (str: string | number): any => {
    const el = document.createElement('textarea');
    el.value = str.toString();
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);

    const selection = document?.getSelection();
    const selectedRangeCount = selection?.rangeCount;

    const selected =
      selectedRangeCount && selectedRangeCount > 0
        ? selection?.getRangeAt(0)
        : false;
    el.select();
    const success = document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
      selection?.removeAllRanges();
      selection?.addRange(selected);
    }
    return success;
  };

  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copy = useCallback(() => {
    if (!isCopied) setIsCopied(copyToClipboard(text));
  }, [text, isCopied]);

  const resetIsCopied = useCallback(() => {
    setIsCopied(false);
  }, []);

  return [isCopied, resetIsCopied, copy];
};
